import { IProperty, IStylingBorder } from "@kuika/kuika-cl-model";
import jsonStringifySafe from "json-stringify-safe";
import * as React from "react";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import { ColorPicker } from "../styling-panel/styling-color-picker";

export interface PropertyFormColorPickerPropertyState {
  propertyValue: string[];
  isColorPickerActive: boolean[];
}

export interface PropertyFormColorPickerPropertyProps {
  property: IProperty;
  applyPropertyValueChanged: (value: any) => void;
}

export class PropertyFormColorPickerArrayProperty extends React.PureComponent<
  PropertyFormColorPickerPropertyProps,
  PropertyFormColorPickerPropertyState
> {
  propertyHelper: PropertyHelper;

  constructor(props) {
    super(props);
    this.propertyHelper = new PropertyHelper();
    this.state = {
      propertyValue: KMainFunctions.getCorrectJSONFromString(this.props.property.symbol.fixedValue),
      isColorPickerActive: new Array(
        KMainFunctions.getCorrectJSONFromString(this.props.property.symbol.fixedValue).length
      ).fill(false)
    };
  }

  componentDidUpdate = (prevProps: PropertyFormColorPickerPropertyProps) => {
    if (prevProps === this.props) return;
    this.setState({ propertyValue: this.getPropertyValueFromProps() });
  };

  getPropertyValueFromProps = (): string[] => {
    return this.state.propertyValue;
  };

  applyPropertyValueChanged = (value: string, index: number) => {
    const { propertyValue } = this.state;
    const newPropertyValue = propertyValue;
    if (!propertyValue[index]) {
      newPropertyValue.push(value);
    } else {
      newPropertyValue[index] = value;
    }
    this.setState({ propertyValue: [...newPropertyValue] });

    if (this.props.applyPropertyValueChanged) {
      this.props.applyPropertyValueChanged(jsonStringifySafe(newPropertyValue));
    }
  };

  addNewDefaultColor = () => {
    const newColorPickerValues = [...this.state.propertyValue, "#ffffff"];

    this.setState({ propertyValue: [...newColorPickerValues] }, () => {
      if (this.props.applyPropertyValueChanged) {
        this.props.applyPropertyValueChanged(jsonStringifySafe([...newColorPickerValues]));
      }
    });
  };

  toggleColorPicker = (event?: any, index?: number) => {
    const newColorPickerState = [...this.state.isColorPickerActive];
    newColorPickerState[index!] = !newColorPickerState[index!];
    this.setState({ isColorPickerActive: newColorPickerState });
    if (event) {
      KMainFunctions.setColorTriggeredPickerPosition(event);
    }
  };

  closeColorPicker = (index: number) => {
    const newColorPickerState = [...this.state.isColorPickerActive];
    newColorPickerState[index] = !newColorPickerState[index];
    this.setState({ isColorPickerActive: newColorPickerState });
    if (this.props.applyPropertyValueChanged) {
      this.props.applyPropertyValueChanged(jsonStringifySafe(this.state.propertyValue));
    }
  };

  handleFillColorClear = (event: any, index: number) => {
    const newColorPickerValues = this.state.propertyValue;
    newColorPickerValues.splice(index, 1);
    this.setState({ propertyValue: [...newColorPickerValues] }, () => {
      if (this.props.applyPropertyValueChanged) {
        this.props.applyPropertyValueChanged(jsonStringifySafe([...newColorPickerValues]));
      }
    });

    const tempObject = {} as IStylingBorder;
    tempObject.borderColor = undefined;
  };

  setColorPickerValue = (color: string, index: number) => {
    const newColorPickerValues = [...this.state.propertyValue];
    newColorPickerValues[index] = color;
    this.setState({ propertyValue: [...newColorPickerValues] }, () => {
      if (this.props.applyPropertyValueChanged) {
        this.props.applyPropertyValueChanged(jsonStringifySafe([...newColorPickerValues]));
      }
    });
  };

  render() {
    const { propertyValue } = this.state;
    return (
      <>
        <span style={{ cursor: "pointer" }} className="kuika_addNavigationLink" onClick={this.addNewDefaultColor}>
          + Add Color
        </span>
        <div
          className="kuika_styleSection kuika_styling_typography_wrapper"
          style={{ marginBottom: 10, flexDirection: "column" }}
        >
          {propertyValue.map((element, index) => {
            return (
              <div style={{ display: "inherit", marginBottom: 7 }}>
                <div style={{ marginRight: 5, marginLeft: 5 }}>
                  <div
                    style={{
                      width: 28,
                      height: 24,
                      borderRadius: "var(--radius-s)",
                      border: "2px solid var(--control-border)",
                      background: this.state.propertyValue[index],
                      textAlign: "right"
                    }}
                    onClick={(e) => this.toggleColorPicker(e, index)}
                  >
                    <div style={{ marginRight: 5, marginTop: 3 }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <g fill="none" fillRule="evenodd">
                          <path d="M0 0H14V14H0z" />
                          <path
                            fill="#ffffff"
                            fillRule="nonzero"
                            d="M7.292 7.47l2.374-2.323c.258-.252.675-.252.933 0 .257.252.257.66 0 .912L7.73 8.863c-.243.238-.636.238-.879 0L3.985 6.06c-.258-.252-.258-.66 0-.912.257-.252.675-.252.932 0L7.292 7.47z"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div
                    className="kuika_colorPicker"
                    style={{
                      display: this.state.isColorPickerActive[index] === true ? "block" : "none"
                    }}
                  >
                    <ColorPicker
                      color={this.state.propertyValue[index]}
                      onChange={(color) => this.setColorPickerValue(color, index)}
                      onCancel={() => this.closeColorPicker(index)}
                      isColorPickerActive={this.state.isColorPickerActive[index] === true}
                      hideHeaderTabs={true}
                    />
                  </div>
                </div>
                <div>
                  <span
                    className="k_Regular-G1-Left"
                    style={{
                      fontSize: "10px",
                      letterSpacing: "0.35px",
                      verticalAlign: "middle"
                    }}
                  >
                    Color {index + 1}
                  </span>
                </div>
                <div style={{ marginLeft: "calc(50% - 12px)" }}>
                  <KuikaButton
                    type="tertiary"
                    color="neutral"
                    isIcon
                    onClick={(event) => this.handleFillColorClear(event, index)}
                  >
                    <KuikaSvg name="trash" width={24} height={24} />
                  </KuikaButton>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }
}
